module.exports = __webpack_public_path__ + "media/images/login_lead-b33900ebc1587e778fedbf10871b293f.png";